import React, { useContext, useEffect, useState } from 'react'
import { CButton, CCard } from '@coreui/react'
import CalendarTable from 'src/components/calendarTable/calendarTable'
import { useParams, useHistory } from 'react-router-dom'
import useAxios from 'axios-hooks'
import { IPTV_CHANNEL_FILTER } from 'src/views/utils/urls'
import { AppContext } from 'src/views/context/app'
import { GlobalContext } from 'src/views/context/GlobalState'
import { getThumbnail } from 'src/views/utils/helper'
import { isEmpty, capitalize } from 'lodash'
import PreviewDetails from '../AssetManager/PreviewDetails'
import moment from 'moment'

const ChannelSchedule = () => {
  const { channelId } = useParams()
  const { setLoader } = useContext(AppContext)
  const history = useHistory()
  const { userSessionObj } = useContext(GlobalContext)
  const [detailObj, setDetailObj] = useState({})
  const [previewContent, setPreviewContent] = useState({})
  const [basicInfo, setBasicInfo] = useState([])

  console.log('channelId', channelId)
  const [{ data: channelDetails, loading: channelDetailsLoading }, channelDetailsCall] = useAxios(
    {
      url: IPTV_CHANNEL_FILTER,
      method: 'post',
    },
    {
      manual: true,
    },
  )

  useEffect(() => {
    channelDetailsCall({
      data: {
        filters: { channel_ids: [channelId] },
        page: '1',
      },
    })
  }, [channelId])

  useEffect(() => {
    setLoader(channelDetailsLoading)
  }, [channelDetailsLoading])

  useEffect(() => {
    if (channelDetails && channelDetails.success) {
      setDetailObj(channelDetails.data[0])
    }
  }, [channelDetails])

  useEffect(() => {
    setBasicInfo([
      {
        property: 'Title',
        value: previewContent.title,
      },
      {
        property: 'Description',
        value: previewContent?.description,
      },
      {
        property: 'Content Type',
        value: previewContent?.video_type,
      },
      {
        property: 'File Type',
        value: previewContent?.asset_type,
      },

      {
        property: 'Category',
        value: !isEmpty(previewContent?.category)
          ? [...previewContent?.category].map((info) => info.name).toString()
          : '',
      },
      { property: 'Status', value: capitalize(String(previewContent?.publish_policy)) },
      {
        property: 'Monetization',
        value:
          previewContent?.active_subscription?.length > 0 ||
          previewContent?.active_ppv_subscription?.length > 0
            ? 'Paid'
            : 'Free',
      },
      {
        property: 'Publish Time',
        value: moment(previewContent?.publish_time).format('DD MMM YYYY'),
      },
      { property: 'Permalink', value: 'N/A' },
    ])
  }, [previewContent])

  return (
    <div className="ml-2 mt-4 pr-3">
      <div className="d-flex">
        <img
          src={getThumbnail(
            userSessionObj.session_data.cf_domain_name,
            detailObj?.thumbnail?.website?.s3_key,
          )}
          alt="channelimg"
          style={{ width: '134px', height: '75px' }}
        />
        <div className="ml-3">
          <p style={{ fontSize: '1.5625vw', fontWeight: 'bold' }} className="mb-0">
            {`Program Calendar for '${detailObj?.name}' Channel`}
          </p>
          <p style={{ fontSize: '0.9375vw' }} className="mb-0">
            {` Preview of Programs and available slots`}
          </p>
        </div>
      </div>
      <CCard className="mt-3">
        {!isEmpty(previewContent) && (
          <PreviewDetails
            onClose={() => setPreviewContent({})}
            cardImage={getThumbnail(
              userSessionObj.session_data.cf_domain_name,
              previewContent?.thumbnail?.website?.s3_key,
            )}
            headline="Content Preview"
            subHeadline="Detailed information about the selected Content"
            basicInfo={basicInfo}
            resolutions={previewContent?.source_asset?.progress}
            playIconForVideo={true}
          />
        )}
        <CalendarTable channelId={channelId} setPreviewDetails={setPreviewContent} />
        <div className="my-2 w-100 d-flex justify-content-end px-4">
          <CButton
            onClick={() => {
              history.push(`/iptv-channels`)
            }}
            color="info"
            className="text-white d-flex align-items-center px-4"
            style={{ backgroundColor: '#20211c' }}
          >
            Back
          </CButton>
        </div>
      </CCard>
    </div>
  )
}

export default ChannelSchedule
